import { CommonModule } from '@angular/common';
export enum ExperimentStage {
  StartInstruction = 1,
  IntensityRatingDemo = 2,
  Training = 3,
  ReadyStart = 4,
  PrepareForContinue = 5, // For restart ongoing experiment
  Experiment = 6,
  Pause = 7,
  Complete = 8,
}
